import React from 'react'
import {useNavigate} from "react-router-dom";
import {ArrowLeftIcon} from "@heroicons/react/20/solid";
import {baseWebUrl} from "../../requests/NetworkRequestAuth0";

// A minimal header showing the VirtualTipz logo and a Back button, with no
// navigation menu. Used on legal pages (Terms, Privacy, Legal landing).
export default function HeaderLogoOnly() {
    let navigate = useNavigate();

    return (
        <div className="relative bg-white dark:bg-gray-900">
            <div className="flex items-center justify-between px-4 py-6 sm:px-6 md:justify-start md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1 md:w-0 md:flex-1">
                    <a onClick={() => {
                        navigate('/');
                    }}>
                        <span className="sr-only">VirtualTipz</span>
                        <img
                            className="block dark:hidden cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogo.png"}
                            alt="VirtualTipzLogo"
                        />
                        <img
                            className="hidden dark:block cursor-pointer h-8 w-auto sm:h-10"
                            src={baseWebUrl + "/VirtualTipzLogoDark.png"}
                            alt="VirtualTipzLogo"
                        />
                    </a>
                </div>
                <div className="-my-2 -mr-2">
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center rounded-md bg-white dark:bg-gray-800 px-3 py-2 text-base font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500"
                    >
                        <ArrowLeftIcon className="mr-2 h-5 w-5" aria-hidden="true"/>
                        Back
                    </button>
                </div>
            </div>
        </div>
    )
}
